// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1tbnu","productName":"Table_productName__9gK1Y"};